import React from 'react'
import styled from 'styled-components'
import { customMedia } from '../../common/customMedia'

import { MyCarousel } from '../../common/MyCarousel'
import { ManagerMessage } from './ManagerMessage'

export interface Props {
  showSubmessage: boolean
}

export const Message = (props: Props) => {
  const { showSubmessage } = props;

  return (
    <>
      {showSubmessage ? 
        <>
          <MessageTitle showSubmessage={showSubmessage}>MESSAGE</MessageTitle>
          <MessageSubTitle>店長メッセージ</MessageSubTitle>
        </>
      : <MessageTitle showSubmessage={showSubmessage}>MESSAGE</MessageTitle>}
      <CarouselWrapper>
        <MyCarousel showArrows={true}>
          <ManagerMessage 
            imagePath='honten_manager.jpg' 
            storeName='シンビ堂薬局軽井沢本店' 
            message='当薬局では、昔から御利用いただいているお客様が数多くいらっしゃいます。また、別荘滞在期間中や軽井沢へ観光にお越しの方など様々な方の御利用もあります。処方箋調剤だけでなく一般用医薬品も数多く取り揃えておりますので、どうぞお気軽にお立ち寄りください。'
          />
          <ManagerMessage 
            imagePath='drugs_manager.jpg' 
            storeName='シンビ堂ドラッグス' 
            message='当店は軽井沢プリンスショッピングプラザ内にあり、薬を中心に、化粧品、ベビー用品等様々な商品を揃え、専門スタッフがお客様のご要望に応え、お薬選びのお手伝いを致します。お気軽にご来店ください。'
          />
          <ManagerMessage 
            imagePath='nakakaruizawa_manager.jpg' 
            storeName='シンビ堂中軽井沢薬局' 
            message='地域の薬局として安心して薬を使っていただくだけでなく、健康をはじめ様々な情報をお伝えできる店舗を目指しています。皆さんに明るく、しっかりとした対応ができるよう、選んでいただける薬局になれるようスタッフ一同心がけています。お気軽にお声かけください。'
          />
          <ManagerMessage 
            imagePath='kariyado_manager.jpg' 
            storeName='シンビ堂借宿薬局' 
            message='子育て世代の方から介護を必要とされるご家庭、高齢者世帯まで薬のことのみならず、健康・介護・福祉等様々な相談に応じ、少しでも皆様のお役に立てればと考えております。処方箋調剤の他、一般薬・介護用品・生活雑貨も取り揃えておりますので、お気軽にお立ち寄り下さい。スタッフ一同、皆様から選ばれる薬局として頑張って参ります。'
          />
          <ManagerMessage 
            imagePath='miyota_manager.jpg' 
            storeName='シンビ堂御代田薬局' 
            message='当店はツルヤみよたショッピングパークのテナントとして敷地内にあり、2020年1月に新しく生まれ変わりました。地域住民の方々をはじめ多くの皆様に選んで頂けるお店を目指しています。薬や健康の事、それ以外のことでもお気軽にご相談・お立ち寄り下さい。スタッフ一同お待ちしております。'
          />
        </MyCarousel>
      </CarouselWrapper>
    </>
  )
}

const MessageTitle = styled.div<{showSubmessage: boolean}>`
  ${props => customMedia.lessThan("medium")`
    font-size: ${props.showSubmessage ? '2.6rem' : '1.6rem'};
    margin-top: 30px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 3.6rem;
    margin-top: 56px;
  `}

  color: #fff;
  font-family: 'Quicksand', sans-serif;
  letter-spacing: 0.1em;
  text-align: center;
`
const MessageSubTitle = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1.2rem;
    margin-top: 5px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    margin-top: 10px;
  `}

  color: #fff;
  font-family: 'Kosugi Maru', sans-serif;
  letter-spacing: 0.36em;
  text-align: center;
`

const CarouselWrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin-top: 20px;
    padding-bottom: 30px;

    ul.control-dots {
      position: relative;
    }
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 40px;
  
    ul.control-dots {
      margin-left: 100px;
      text-align: left;
      top: 375px;
    }
  `}

  li.slide, li.slide.selected {
    background-color: #00559F;
  }
`